import { memo } from 'react';
import { compose } from 'redux';
import { Route } from 'react-router';
import { useTranslation } from 'react-i18next';

import { withRequiredLicense } from 'providers/root/AuthProvider';
import Layout, { ViewPanelLayout } from 'Layout';

import { useCommandBarReports } from 'hooks/useCommandBarAttributes';

import Filters from 'components/ReportModifiers/Filters';
import ModifiersByProduct from 'components/ReportModifiers/ModifiersByProduct';
import ModifierGroupsByOption from 'components/ReportModifiers/ModifierGroupsByOption';

import Navigation from './Navigation';
import { FiltersProvider } from './context';

const ReportModifiers = () => {
  const { t } = useTranslation('reports');
  const commandBarHook = useCommandBarReports();

  return (
    <Layout>
      <FiltersProvider>
        <ViewPanelLayout
          commandBarHook={commandBarHook}
          goBackPath="/reports"
          pb={4}
          title={t('navigation.modifiersReport')}
        >
          <Filters />

          <Navigation />

          <Route exact path="/reports/modifiers/modifiersByProduct">
            <ModifiersByProduct t={t} />
          </Route>

          <Route exact path="/reports/modifiers/modifiersByOption">
            <ModifierGroupsByOption />
          </Route>
        </ViewPanelLayout>
      </FiltersProvider>
    </Layout>
  );
};

export default compose(memo, withRequiredLicense())(ReportModifiers);
